import { render, staticRenderFns } from "./Subsystem.vue?vue&type=template&id=1456533f&scoped=true&"
import script from "./Subsystem.vue?vue&type=script&lang=ts&"
export * from "./Subsystem.vue?vue&type=script&lang=ts&"
import style0 from "./Subsystem.vue?vue&type=style&index=0&id=1456533f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1456533f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex})
